type AccessData = Partial<Record<'Add' | 'Delete' | 'Edit' | 'Export' | 'ExportedFiles' | 'Print' | 'Read' | 'ReadDeleted' | 'ReadVersions' | 'SetCurrentVersion' | 'Undelete', boolean>>

export class AccessClass {
  canAdd: boolean
  canDelete: boolean
  canEdit: boolean
  canExport: boolean
  canExportedFiles: boolean
  canPrint: boolean
  canRead: boolean
  canReadDeleted: boolean
  canReadVersions: boolean
  canSetCurrentVersion: boolean
  canUndelete: boolean

  constructor (data: AccessData) {
    this.canAdd = Boolean(data?.Add)
    this.canDelete = Boolean(data?.Delete)
    this.canEdit = Boolean(data?.Edit)
    this.canExport = Boolean(data?.Export)
    this.canExportedFiles = Boolean(data?.ExportedFiles)
    this.canPrint = Boolean(data?.Print)
    this.canRead = Boolean(data?.Read)
    this.canReadDeleted = Boolean(data?.ReadDeleted)
    this.canReadVersions = Boolean(data?.ReadVersions)
    this.canSetCurrentVersion = Boolean(data?.SetCurrentVersion)
    this.canUndelete = Boolean(data?.Undelete)
  }
}
